import './NotificationsHeader.scss';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import IconButton from 'fe-design-base/molecules/IconButton';
import Tabs from 'fe-design-base/molecules/Tabs';
import { OnChangeType } from 'fe-design-base/molecules/Tabs/Tabs';

import { getCurrentUserIsManagerial } from 'selectors/session';

import { selectUnreadCounts } from 'features/notifications/slice';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cxEl } = cxHelpers('NotificationsHeader');

const BADGE_VARIANT = 'loud' as const;

type NotificationsHeaderProps = {
  tabValue: string;
  handleTabChange: OnChangeType;
  handleClose: () => void;
};

const NotificationsHeader = ({
  tabValue,
  handleTabChange,
  handleClose,
}: NotificationsHeaderProps) => {
  const isManagerial = useSelector(getCurrentUserIsManagerial);
  const unreadCounts = useSelector(selectUnreadCounts);

  const options = useMemo(() => {
    const allOptions = [
      {
        label: toI18n('requests_feed.tabs.team'),
        value: 'team-requests',
        badgeText: unreadCounts.team > 0 ? unreadCounts.team : undefined,
        badgeVariant: BADGE_VARIANT,
      },
      {
        label: toI18n('requests_feed.tabs.my'),
        value: 'my-requests',
        badgeText: unreadCounts.my > 0 ? unreadCounts.my : undefined,
        badgeVariant: BADGE_VARIANT,
      },
      {
        label: toI18n('requests_feed.tabs.alerts'),
        value: 'alerts',
        badgeText: unreadCounts.alerts > 0 ? unreadCounts.alerts : undefined,
        badgeVariant: BADGE_VARIANT,
      },
    ];

    return isManagerial ? allOptions : [allOptions[1]];
  }, [isManagerial, unreadCounts.my, unreadCounts.team, unreadCounts.alerts]);

  return (
    <Box row alignItemsCenter>
      <Box grow={1}>
        <Tabs
          scrollable
          noPadding
          tabValue={tabValue}
          options={options}
          onChange={handleTabChange}
          className={cxEl('tabs')}
        />
      </Box>

      <IconButton
        icon="Close"
        label={toI18n('notifications.close_drawer')}
        size="small"
        onClick={handleClose}
      />
    </Box>
  );
};

export default NotificationsHeader;
